import { TrackEventConfig } from '@gjensidige/core-analytics/lib/types';

export const DEFAULT_TRACKING: TrackEventConfig = {
  eventAction: 'click',
  eventCategory: 'alert_information',
  eventKey: 'alert',
  eventLabel: '',
  eventSource: 'PACKAGE_NAME',
  eventVersion: 'VERSION_NUMBER'
};
